import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { InformationPageService } from 'src/app/services/informationPage.service';
import { TranslateService } from '@ngx-translate/core';
import { BrowserStorageService } from 'src/app/services/storage.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-regulations',
  templateUrl: './regulations.component.html', encapsulation: ViewEncapsulation.None,
  styleUrls: ['./regulations.component.scss']
})
export class RegulationsComponent implements OnInit {

  regulationsHtml: string = '';

  constructor(
    private pageService: InformationPageService,
    private translate: TranslateService,
    private browserStorageService: BrowserStorageService, private title: Title) { }

  ngOnInit(): void {
    this.initContent(null);
    this.translate.onLangChange.subscribe(
      (lang: any) => { this.initContent(lang.lang); }
    );
    this.translate.get('title_agreement').subscribe({
      next: (title) => {
        this.title.setTitle(title);
      }
    });
  }

  private initContent(lang: string): void {
    if (lang == null) {
      lang = this.browserStorageService.get("_lang");
      if (lang == null || lang == '') {
        lang = 'pl';
      }
    }
    this.pageService.getInformationPage(this.pageService.PAGES.TERMS_AND_CONDS, lang).subscribe((response: any) => {
      this.regulationsHtml = response.data.page[Object.keys(response.data.page)[0]];
    });
  }

}
